var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_65390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 16.5H14C13.6022 16.5 13.2206 16.342 12.9393 16.0607C12.658 15.7794 12.5 15.3978 12.5 15V11.25C12.5 11.0511 12.421 10.8603 12.2803 10.7197C12.1397 10.579 11.9489 10.5 11.75 10.5H11",
    stroke: "#B5BDC9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 7.5C11.9179 7.5 11.75 7.33211 11.75 7.125C11.75 6.91789 11.9179 6.75 12.125 6.75",
    stroke: "#B5BDC9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 7.5C12.3321 7.5 12.5 7.33211 12.5 7.125C12.5 6.91789 12.3321 6.75 12.125 6.75",
    stroke: "#B5BDC9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.25C18.7132 23.25 23.75 18.2132 23.75 12C23.75 5.7868 18.7132 0.75 12.5 0.75C6.2868 0.75 1.25 5.7868 1.25 12C1.25 18.2132 6.2868 23.25 12.5 23.25Z",
    stroke: "#B5BDC9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_65390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a3079e797a5b57c8116e3d3d2762fb90.svg";
export { ForwardRef as ReactComponent };